
import { Component, Prop } from 'vue-property-decorator'
import Categories from '@/components/options/Categories.vue'
import Options from '@/components/options/Options.vue'
import { OptionValidator } from '@/mixins/OptionValidator'
import { MenuItem } from '@/interfaces/MenuItem'
import { OptionCategoryApiModel } from '@/interfaces/OptionCategoryApiModel'
import { OptionApiModel } from '@/interfaces/OptionApiModel'
import { ConfigurationApiModel } from '@/interfaces/ConfigurationApiModel'
import { namespace } from 'vuex-class'
import { mixins } from 'vue-class-component'
import lodash from 'lodash'
import { ConfirmModalData } from '@/interfaces/ConfirmModalData'
import { SubOptionType } from '@/interfaces/SubOptionType'
import { RequiredOptionsLogic } from '@/interfaces/RequiredOptionsLogic'
import { OptionSelectionMixin } from '@/mixins/OptionSelectionMixin'

const currentModel = namespace('currentModel')

@Component({
  components: {
    Categories,
    Options
  }
})
export default class OptionSelector extends mixins(OptionValidator, OptionSelectionMixin) {
  @Prop() readonly menuItem!: MenuItem

  mounted() {
    const categoryWithSelectedOption = this.categoryList.find(c => c.options.some(o => this.isOptionSelected(o)))
    let category = categoryWithSelectedOption || this.categoryList[0]
    if (this.$route.params.categoryUrl) {
      category = this.categoryList.find(c => c.code === this.$route.params.categoryUrl) || category
    }
    this.setActiveCategory(category as OptionCategoryApiModel)

    this.$root.$on('removeOption', async (optionItem: OptionApiModel) => await this.deselectOption(optionItem))
  }

  public categorySelected: OptionCategoryApiModel = {
    id: 0,
    code: '',
    description: '',
    name: '',
    options: [],
    subOptionTypes: [],
    seq: 0,
    menuItemId: 0
  }

  public showOtherOptions = false

  @currentModel.State
  public fetchedData!: boolean

  public async optionClicked(optionItem: OptionApiModel): Promise<void> {
    if (this.isOptionSelected(optionItem) && optionItem.removable) {
      this.deselectOption(optionItem)
    } else {
      this.selectOption(optionItem)
    }
  }

  public setActiveCategory(category: OptionCategoryApiModel): void {
    this.categorySelected = category
  }

  public toggleOptions(showOtherOptions: boolean) {
    this.showOtherOptions = showOtherOptions
  }

  get categoryList(): Array<OptionCategoryApiModel> {
    const menuItem = this.menuItem

    let categories = menuItem ? menuItem.categories : []

    categories = lodash.filter(categories, (category) => !this.hideCategory(category))

    return lodash.sortBy(categories, c => c.seq)
  }
}
